import React from 'react';

export default {
  outline: (
    <>
      <g
        id="bg-lines"
        transform="translate(23.000000, 19.000000)"
        strokeWidth="0.5"
      >
        <polyline
          id="Path"
          stroke="#262626"
          points="469 115 512 115 512 141 469 141 469 115"
        />
        <path d="M474.5,115 L474.5,141" id="Path" stroke="#262626" />
        <path d="M481.5,115 L481.5,141" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="469 86 512 86 512 112 469 112 469 86"
        />
        <path d="M487.5,115 L487.5,141" id="Path" stroke="#262626" />
        <path d="M493.5,115 L493.5,141" id="Path" stroke="#262626" />
        <path d="M499.5,115 L499.5,141" id="Path" stroke="#262626" />
        <path d="M505.5,115 L505.5,141" id="Path" stroke="#262626" />
        <path d="M474.5,86 L474.5,112" id="Path" stroke="#262626" />
        <path d="M481.5,86 L481.5,112" id="Path" stroke="#262626" />
        <path d="M487.5,86 L487.5,112" id="Path" stroke="#262626" />
        <path d="M493.5,86 L493.5,112" id="Path" stroke="#262626" />
        <path d="M499.5,86 L499.5,112" id="Path" stroke="#262626" />
        <path d="M505.5,86 L505.5,112" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="439 86 537 86 537 141 439 141"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="238 115 281 115 281 141 238 141 238 115"
        />
        <path d="M243.5,115 L243.5,141" id="Path" stroke="#262626" />
        <path d="M250.5,115 L250.5,141" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="238 86 281 86 281 112 238 112 238 86"
        />
        <path d="M256.5,115 L256.5,141" id="Path" stroke="#262626" />
        <path d="M262.5,115 L262.5,141" id="Path" stroke="#262626" />
        <path d="M268.5,115 L268.5,141" id="Path" stroke="#262626" />
        <path d="M274.5,115 L274.5,141" id="Path" stroke="#262626" />
        <path d="M243.5,86 L243.5,112" id="Path" stroke="#262626" />
        <path d="M250.5,86 L250.5,112" id="Path" stroke="#262626" />
        <path d="M256.5,86 L256.5,112" id="Path" stroke="#262626" />
        <path d="M262.5,86 L262.5,112" id="Path" stroke="#262626" />
        <path d="M268.5,86 L268.5,112" id="Path" stroke="#262626" />
        <path d="M274.5,86 L274.5,112" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="208 86 306 86 306 141 208 141"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="0.825520833 68.9480654 0.825520833 142.64916 31.4400987 142.64916 31.4400987 0.234375 0.825520833 0.234375 0.825520833 24.3046875"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="0.825520833 255.294516 0.825520833 259.894531 9.36223125 318.589387 31.4400987 318.589387 31.4400987 142.64916 0.825520833 142.64916 0.825520833 210.221256"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="260.022609 183.818721 214.505776 183.818721 214.505776 217.27597 260.022609 217.27597 260.022609 183.818721"
        />
        <polygon
          id="Path"
          stroke="#262626"
          fillRule="nonzero"
          points="210.271652 221.661487 210.271652 179.221001 264.256733 179.221001 264.256733 221.661487"
        />
        <path
          d="M438.879883,141 L391.323242,141"
          id="Path-2"
          stroke="#262626"
        />
      </g>
      <g id="staircase-copy" transform="translate(-3.000000, 40.000000)">
        <path
          d="M28.0218806,26.4681104 C28.2143241,25.7594311 28.03138,25.0015556 27.5368265,24.4586953 L24.4879147,27.091722 C24.9411818,27.7385903 25.7129126,28.0845223 26.4974247,27.9924943 C27.2499597,27.8081459 27.8375235,27.2206099 28.0218806,26.4681104 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <polygon
          id="Path"
          fill="#C8AA6D"
          points="18.1822108 46.9780029 18.2515042 46.9780029 18.2515042 46.9780029"
        />
        <path
          d="M18.2515042,46.9780029 C20.9789894,47.9703963 23.8747814,48.4176926 26.7745985,48.2945163 L18.2515042,46.9780029 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M18.1822108,46.9780029 L10.352051,41.9891102 C12.5934702,44.1700029 15.2584472,45.8679611 18.1822108,46.9780029 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <polygon
          id="Path"
          fill="#C8AA6D"
          points="5.15504226 34.2979005 5.15504226 34.2286103 5.15504226 34.2979005"
        />
        <path
          d="M10.352051,41.9891102 L5.15504226,34.2979005 C6.35185261,37.1853756 8.11952623,39.801409 10.352051,41.9891102 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M3.56129292,25.2901774 C3.43044737,28.417955 3.97399184,31.5372804 5.15504226,34.4364808 L3.56129292,25.2901774 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M5.77868331,16.0052936 C4.43168466,18.9227905 3.6779554,22.0788828 3.56129292,25.2901774 L5.77868331,16.0052936 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M5.77868331,16.0052936 L11.5300396,8.66053482 C9.14114361,10.6996781 7.18546555,13.1971731 5.77868331,16.0052936 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M19.7066667,4.50312418 C16.6992113,5.35407393 13.9103971,6.84294681 11.5300396,8.86840536 L19.7066667,4.50312418 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M28.9919889,3.5330617 C27.8380942,3.46523116 26.6812112,3.46523116 25.5273164,3.5330617 C23.5537314,3.60750045 21.5977148,3.93348783 19.7066667,4.50312418 L28.9919889,3.5330617 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M28.9919889,3.5330617 L37.792257,6.65111968 C35.1106493,5.00472322 32.1119953,3.94225819 28.9919889,3.5330617 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M37.792257,6.65111968 L44.721602,13.025816 C42.8775471,10.4445974 40.518055,8.27396716 37.792257,6.65111968 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M26.7745985,23.9043739 C26.5015353,23.8368688 26.2161404,23.8368688 25.9430771,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M27.467533,24.3894051 L26.7745985,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M47.8398072,31.6648737 L26.7745985,23.973664"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.3493278,27.0224318 C24.8025949,27.6693001 25.5743257,28.0152321 26.3588378,27.9232041 C27.1464403,27.7973587 27.792594,27.2320009 28.0218806,26.4681104 C28.2224242,25.7259378 28.0110124,24.933181 27.467533,24.3894051"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M43.6129068,39.979695 L27.467533,24.4586953"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d=""
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M18.1822108,46.9780029 C20.9349606,47.9655374 23.8524392,48.4125493 26.7745985,48.2945163"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M10.352051,41.9891102 C12.5820957,44.1843307 15.2502659,45.8843236 18.1822108,46.9780029"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M18.2515042,46.9780029 L27.8832937,26.7452711"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.15504226,34.2286103 C6.32598323,37.1501883 8.09639088,39.7938722 10.352051,41.9891102"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M10.352051,41.9891102 L27.3982396,27.4381729"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M3.56129292,25.2901774 C3.43044737,28.417955 3.97399184,31.5372804 5.15504226,34.4364808"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.15504226,34.2979005 L26.6360116,27.853914"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.77868331,16.0052936 C4.43168466,18.9227905 3.6779554,22.0788828 3.56129292,25.2901774"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M3.56129292,25.0823069 L25.8044902,27.9232041"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M11.5300396,8.66053482 C9.14114361,10.6996781 7.18546555,13.1971731 5.77868331,16.0052936"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.84797676,16.0745838 L24.9729688,27.6460434"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M19.7066667,4.50312418 C16.6992113,5.35407393 13.9103971,6.84294681 11.5300396,8.86840536"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.072154,26.2602399 C24.0044283,26.5097909 24.0044283,26.7728808 24.072154,27.0224318"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M11.5300396,8.729825 L24.4186212,27.0224318"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.9919889,3.5330617 C25.8631087,3.1938342 22.6978561,3.5245166 19.7066667,4.50312418"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.072154,25.2901774 C24.0017426,25.5628666 24.0017426,25.8489703 24.072154,26.1216595"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M19.7066667,4.29525365 L24.072154,26.3295301"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M37.792257,6.65111968 C35.1106493,5.00472322 32.1119953,3.94225819 28.9919889,3.5330617"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.4186212,24.6665658 C24.2342552,24.8833152 24.114239,25.1473382 24.072154,25.4287578"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M29.0612824,3.5330617 L24.072154,25.4287578"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M44.5830151,13.025816 C42.7389602,10.4445974 40.3794681,8.27396716 37.6536701,6.65111968"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M25.0422623,24.0429542 C24.7720164,24.1773697 24.5530431,24.3963327 24.4186212,24.6665658"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M37.792257,6.65111968 L24.4186212,24.6665658"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M26.7745985,48.2945163 C35.0093708,48.0431585 42.444986,43.3019509 46.1467453,35.94216 C49.8485045,28.582369 49.2217007,19.7863838 44.5137216,13.025816"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
        />
        <path
          d="M25.8737837,23.8350837 L25.0422623,23.8350837"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M44.5830151,13.0951062 L25.1115557,24.1122444"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M26.7053051,23.9043739 C26.4322418,23.8368688 26.1468469,23.8368688 25.8737837,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M48.1862744,21.617798 L25.8737837,23.8350837"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.0218806,26.2602399 L28.0911741,48.2945163"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.0911741,25.4980479 L36.6835618,45.7307797"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
      </g>
      <g id="staircase-copy-2" transform="translate(-3.000000, 226.000000)">
        <path
          d="M28.0218806,26.4681104 C28.2143241,25.7594311 28.03138,25.0015556 27.5368265,24.4586953 L24.4879147,27.091722 C24.9411818,27.7385903 25.7129126,28.0845223 26.4974247,27.9924943 C27.2499597,27.8081459 27.8375235,27.2206099 28.0218806,26.4681104 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <polygon
          id="Path"
          fill="#C8AA6D"
          points="18.1822108 46.9780029 18.2515042 46.9780029 18.2515042 46.9780029"
        />
        <path
          d="M18.2515042,46.9780029 C20.9789894,47.9703963 23.8747814,48.4176926 26.7745985,48.2945163 L18.2515042,46.9780029 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M18.1822108,46.9780029 L10.352051,41.9891102 C12.5934702,44.1700029 15.2584472,45.8679611 18.1822108,46.9780029 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <polygon
          id="Path"
          fill="#C8AA6D"
          points="5.15504226 34.2979005 5.15504226 34.2286103 5.15504226 34.2979005"
        />
        <path
          d="M10.352051,41.9891102 L5.15504226,34.2979005 C6.35185261,37.1853756 8.11952623,39.801409 10.352051,41.9891102 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M3.56129292,25.2901774 C3.43044737,28.417955 3.97399184,31.5372804 5.15504226,34.4364808 L3.56129292,25.2901774 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M5.77868331,16.0052936 C4.43168466,18.9227905 3.6779554,22.0788828 3.56129292,25.2901774 L5.77868331,16.0052936 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M5.77868331,16.0052936 L11.5300396,8.66053482 C9.14114361,10.6996781 7.18546555,13.1971731 5.77868331,16.0052936 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M19.7066667,4.50312418 C16.6992113,5.35407393 13.9103971,6.84294681 11.5300396,8.86840536 L19.7066667,4.50312418 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M28.9919889,3.5330617 C27.8380942,3.46523116 26.6812112,3.46523116 25.5273164,3.5330617 C23.5537314,3.60750045 21.5977148,3.93348783 19.7066667,4.50312418 L28.9919889,3.5330617 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M28.9919889,3.5330617 L37.792257,6.65111968 C35.1106493,5.00472322 32.1119953,3.94225819 28.9919889,3.5330617 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M37.792257,6.65111968 L44.721602,13.025816 C42.8775471,10.4445974 40.518055,8.27396716 37.792257,6.65111968 Z"
          id="Path"
          fill="#C8AA6D"
        />
        <path
          d="M26.7745985,23.9043739 C26.5015353,23.8368688 26.2161404,23.8368688 25.9430771,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M27.467533,24.3894051 L26.7745985,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M47.8398072,31.6648737 L26.7745985,23.973664"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.3493278,27.0224318 C24.8025949,27.6693001 25.5743257,28.0152321 26.3588378,27.9232041 C27.1464403,27.7973587 27.792594,27.2320009 28.0218806,26.4681104 C28.2224242,25.7259378 28.0110124,24.933181 27.467533,24.3894051"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M43.6129068,39.979695 L27.467533,24.4586953"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d=""
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M18.1822108,46.9780029 C20.9349606,47.9655374 23.8524392,48.4125493 26.7745985,48.2945163"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M10.352051,41.9891102 C12.5820957,44.1843307 15.2502659,45.8843236 18.1822108,46.9780029"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M18.2515042,46.9780029 L27.8832937,26.7452711"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.15504226,34.2286103 C6.32598323,37.1501883 8.09639088,39.7938722 10.352051,41.9891102"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M10.352051,41.9891102 L27.3982396,27.4381729"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M3.56129292,25.2901774 C3.43044737,28.417955 3.97399184,31.5372804 5.15504226,34.4364808"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.15504226,34.2979005 L26.6360116,27.853914"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.77868331,16.0052936 C4.43168466,18.9227905 3.6779554,22.0788828 3.56129292,25.2901774"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M3.56129292,25.0823069 L25.8044902,27.9232041"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M11.5300396,8.66053482 C9.14114361,10.6996781 7.18546555,13.1971731 5.77868331,16.0052936"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M5.84797676,16.0745838 L24.9729688,27.6460434"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M19.7066667,4.50312418 C16.6992113,5.35407393 13.9103971,6.84294681 11.5300396,8.86840536"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.072154,26.2602399 C24.0044283,26.5097909 24.0044283,26.7728808 24.072154,27.0224318"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M11.5300396,8.729825 L24.4186212,27.0224318"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.9919889,3.5330617 C25.8631087,3.1938342 22.6978561,3.5245166 19.7066667,4.50312418"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.072154,25.2901774 C24.0017426,25.5628666 24.0017426,25.8489703 24.072154,26.1216595"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M19.7066667,4.29525365 L24.072154,26.3295301"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M37.792257,6.65111968 C35.1106493,5.00472322 32.1119953,3.94225819 28.9919889,3.5330617"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M24.4186212,24.6665658 C24.2342552,24.8833152 24.114239,25.1473382 24.072154,25.4287578"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M29.0612824,3.5330617 L24.072154,25.4287578"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M44.5830151,13.025816 C42.7389602,10.4445974 40.3794681,8.27396716 37.6536701,6.65111968"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M25.0422623,24.0429542 C24.7720164,24.1773697 24.5530431,24.3963327 24.4186212,24.6665658"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M37.792257,6.65111968 L24.4186212,24.6665658"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M26.7745985,48.2945163 C35.0093708,48.0431585 42.444986,43.3019509 46.1467453,35.94216 C49.8485045,28.582369 49.2217007,19.7863838 44.5137216,13.025816"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
        />
        <path
          d="M25.8737837,23.8350837 L25.0422623,23.8350837"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M44.5830151,13.0951062 L25.1115557,24.1122444"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M26.7053051,23.9043739 C26.4322418,23.8368688 26.1468469,23.8368688 25.8737837,23.9043739"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M48.1862744,21.617798 L25.8737837,23.8350837"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.0218806,26.2602399 L28.0911741,48.2945163"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
        <path
          d="M28.0911741,25.4980479 L36.6835618,45.7307797"
          id="Path"
          stroke="#262626"
          strokeWidth="0.5"
          fill="#262626"
        />
      </g>
      <path
        d="M691.08,167.66 L690.6,169.1 L687.8,177.7 L686.8,177.7 L682.16,163.9 L681,163.8 L681,163.6 L686,163.6 L686,163.8 L684.06,163.9 L687.94,175.9 L688.14,175.9 L690.92,167.1 L689.96,163.9 L688.4,163.8 L688.4,163.6 L693.6,163.6 L693.6,163.8 L691.86,163.9 L695.24,175.9 L695.44,175.9 L698.46,164.5 L696.4,163.8 L696.4,163.6 L700.8,163.6 L700.8,163.8 L698.78,164.5 L695.2,177.7 L694.1,177.7 L691.08,167.66 Z M708.465,171.8 L701.625,171.8 C701.565,174.4 702.925,176.7 705.265,176.7 C706.565,176.7 707.965,175.8 708.465,174.8 L708.665,174.8 C708.265,176.4 706.765,177.8 704.865,177.8 C701.765,177.8 700.065,175.3 700.065,172.6 C700.065,169.3 702.465,167.4 704.965,167.4 C706.865,167.4 709.065,168.5 708.465,171.8 Z M704.865,167.6 C703.145,167.6 701.865,169 701.665,171.6 L706.665,171.5 C707.165,168.8 706.165,167.6 704.865,167.6 Z M714.23,177.8 C712.97,177.8 711.89,177.22 711.23,176.6 L711.13,177.8 L710.93,177.8 L710.93,174.8 L711.13,174.8 C711.37,175.48 711.73,176.16 712.19,176.7 C712.65,177.24 713.25,177.6 714.03,177.6 C715.43,177.6 716.33,176.72 716.33,175.5 C716.33,174 714.87,173.56 713.73,173.1 C712.19,172.48 711.03,171.8 711.03,170.1 C711.03,168.5 712.37,167.4 714.43,167.4 C715.25,167.4 716.33,167.7 717.23,168.5 L717.33,167.4 L717.53,167.4 L717.53,170.4 L717.33,170.4 C717.03,169.4 716.57,168.72 716.05,168.26 C715.53,167.82 714.93,167.6 714.33,167.6 C713.13,167.6 712.43,168.42 712.43,169.4 C712.43,170.7 713.73,171.3 714.83,171.7 C716.31,172.24 717.93,173 717.93,174.8 C717.93,176.7 716.33,177.8 714.23,177.8 Z M723.195,167.9 L723.195,175.4 C723.195,176.9 723.695,177.3 724.595,177.3 C724.995,177.3 725.495,177.2 726.195,176.9 L726.195,177.1 C725.195,177.6 724.595,177.8 723.595,177.8 C722.195,177.8 721.595,177.1 721.595,175.4 L721.595,167.9 L719.995,167.9 L719.995,167.7 L721.595,167.6 L722.995,165.2 L723.195,165.2 L723.195,167.6 L726.195,167.6 L726.195,167.9 L723.195,167.9 Z M733.525,177.4 L736.125,177.3 L736.125,164.1 L733.525,164.5 L733.525,164.3 L737.525,163.4 L737.725,163.4 L737.725,177.3 L740.325,177.4 L740.325,177.6 L733.525,177.6 L733.525,177.4 Z M746.590001,177.6 C748.510001,177.6 749.550001,175.96 749.550001,173.84 C749.550001,172.02 748.670001,170.24 746.530001,170.24 L745.810001,170.24 L745.810001,170 L746.330001,170 C748.150001,170 749.030001,168.26 749.030001,166.88 C749.030001,165.52 748.190001,164.2 746.590001,164.2 C744.590001,164.2 743.790001,165.5 743.390001,166.58 L743.190001,166.58 C743.590001,164.9 745.190001,163.4 747.090001,163.4 C749.230001,163.4 750.770001,164.66 750.770001,166.56 C750.770001,168.24 749.510001,169.44 747.230001,170.02 L747.230001,170.12 C749.610001,170.34 751.290001,171.52 751.290001,173.76 C751.290001,176.48 748.990001,177.8 746.490001,177.8 C744.310001,177.8 742.590001,176.5 742.590001,175.2 C742.590001,174.64 743.030001,174.2 743.590001,174.2 C745.050001,174.2 745.070001,176.48 743.290001,176.1 L743.290001,176.3 C743.790001,176.7 744.590001,177.6 746.590001,177.6 Z M756.955001,167.9 L756.955001,175.4 C756.955001,176.9 757.455001,177.3 758.355001,177.3 C758.755001,177.3 759.255001,177.2 759.955001,176.9 L759.955001,177.1 C758.955001,177.6 758.355001,177.8 757.355001,177.8 C755.955001,177.8 755.355001,177.1 755.355001,175.4 L755.355001,167.9 L753.755001,167.9 L753.755001,167.7 L755.355001,167.6 L756.755001,165.2 L756.955001,165.2 L756.955001,167.6 L759.955001,167.6 L759.955001,167.9 L756.955001,167.9 Z M771.620001,177.3 L773.420001,177.4 L773.420001,177.6 L768.620001,177.6 L768.620001,177.4 L770.020001,177.3 L770.020001,170.4 C770.020001,169.1 769.620001,168 768.120001,168 C767.220001,168 766.620001,168.3 765.220001,169.7 L765.220001,177.3 L767.020001,177.4 L767.020001,177.6 L761.820001,177.6 L761.820001,177.4 L763.620001,177.3 L763.620001,163.4 L762.020001,163.4 L762.020001,163.2 L765.020001,163 L765.220001,163 L765.220001,169.2 L765.420001,169.2 C766.580001,168.04 767.660001,167.4 769.120001,167.4 C770.460001,167.4 771.620001,168.2 771.620001,170.4 L771.620001,177.3 Z M782.050001,176.7 L784.150001,177.4 L784.150001,177.6 L779.750001,177.6 L779.750001,177.4 L781.730001,176.7 L785.590001,164.7 L787.050001,163.4 L792.190001,177.3 L793.350001,177.4 L793.350001,177.6 L788.350001,177.6 L788.350001,177.4 L790.290001,177.3 L788.630001,172.6 L783.330001,172.6 L782.050001,176.7 Z M785.950001,165 L785.750001,165 L783.390001,172.36 L788.550001,172.36 L785.950001,165 Z M798.875001,176.24 L799.075001,176.24 L801.555001,168.3 L800.015001,167.8 L800.015001,167.6 L803.615001,167.6 L803.615001,167.8 L801.855001,168.3 L798.815001,177.7 L797.715001,177.7 L793.755001,167.9 L792.415001,167.8 L792.415001,167.6 L797.615001,167.6 L797.615001,167.8 L795.655001,167.9 L798.875001,176.24 Z M812.880001,171.8 L806.040001,171.8 C805.980001,174.4 807.340001,176.7 809.680001,176.7 C810.980001,176.7 812.380001,175.8 812.880001,174.8 L813.080001,174.8 C812.680001,176.4 811.180001,177.8 809.280001,177.8 C806.180001,177.8 804.480001,175.3 804.480001,172.6 C804.480001,169.3 806.880001,167.4 809.380001,167.4 C811.280001,167.4 813.480001,168.5 812.880001,171.8 Z M809.280001,167.6 C807.560001,167.6 806.280001,169 806.080001,171.6 L811.080001,171.5 C811.580001,168.8 810.580001,167.6 809.280001,167.6 Z M824.745001,177.3 L826.545001,177.4 L826.545001,177.6 L821.745001,177.6 L821.745001,177.4 L823.145001,177.3 L823.145001,170.4 C823.145001,169.1 822.745001,168 821.245001,168 C820.345001,168 819.745001,168.3 818.345001,169.7 L818.345001,177.3 L820.145001,177.4 L820.145001,177.6 L814.945001,177.6 L814.945001,177.4 L816.745001,177.3 L816.745001,167.8 L815.145001,167.8 L815.145001,167.6 L818.145001,167.4 L818.345001,167.4 L818.345001,169.2 L818.545001,169.2 C819.705001,168.04 820.785001,167.4 822.245001,167.4 C823.585001,167.4 824.745001,168.2 824.745001,170.4 L824.745001,177.3 Z M829.210001,167.8 L827.410001,167.8 L827.410001,167.6 L830.410001,167.4 L830.810001,167.4 L830.810001,174.8 C830.810001,176.1 831.210001,177.2 832.710001,177.2 C833.610001,177.2 834.210001,176.9 835.410001,175.5 L835.410001,167.8 L833.610001,167.8 L833.610001,167.6 L836.610001,167.4 L837.010001,167.4 L837.010001,177.4 L838.810001,177.4 L838.810001,177.6 L835.610001,177.8 L835.410001,177.8 L835.410001,176 L835.210001,176 C834.210001,177.1 833.170001,177.8 831.710001,177.8 C830.370001,177.8 829.210001,177 829.210001,174.8 L829.210001,167.8 Z M848.675002,171.8 L841.835002,171.8 C841.775001,174.4 843.135002,176.7 845.475001,176.7 C846.775001,176.7 848.175002,175.8 848.675002,174.8 L848.875002,174.8 C848.475001,176.4 846.975001,177.8 845.075002,177.8 C841.975001,177.8 840.275001,175.3 840.275001,172.6 C840.275001,169.3 842.675002,167.4 845.175002,167.4 C847.075002,167.4 849.275001,168.5 848.675002,171.8 Z M845.075002,167.6 C843.355002,167.6 842.075002,169 841.875002,171.6 L846.875002,171.5 C847.375002,168.8 846.375002,167.6 845.075002,167.6 Z"
        id="West-13th-Avenue"
        fill="#1A373C"
        transform="translate(764.937501, 170.400000) rotate(-90.000000) translate(-764.937501, -170.400000) "
      />
      <path
        d="M301.3,372.7 L303.4,373.4 L303.4,373.6 L299,373.6 L299,373.4 L300.98,372.7 L304.84,360.7 L306.3,359.4 L311.44,373.3 L312.6,373.4 L312.6,373.6 L307.6,373.6 L307.6,373.4 L309.54,373.3 L307.88,368.6 L302.58,368.6 L301.3,372.7 Z M305.2,361 L305,361 L302.64,368.36 L307.8,368.36 L305.2,361 Z M317.465,366 L317.665,366 C318.565,364.4 319.365,363.4 320.365,363.4 C321.005,363.4 321.465,363.84 321.465,364.4 C321.465,365.8 319.465,365.9 319.365,364.3 L319.165,364.3 C318.645,364.8 318.165,365.5 317.465,366.9 L317.465,373.3 L319.265,373.4 L319.265,373.6 L314.065,373.6 L314.065,373.4 L315.865,373.3 L315.865,363.8 L314.265,363.8 L314.265,363.6 L317.265,363.4 L317.465,363.4 L317.465,366 Z M325.53,365.04 L325.53,372.56 C326.33,373.1 327.01,373.5 328.03,373.5 C329.71,373.5 331.13,372.2 331.13,368.6 C331.13,365 329.71,363.8 328.03,363.8 C327.01,363.8 326.13,364.52 325.53,365.04 Z M323.93,373.8 L323.93,359.4 L322.33,359.4 L322.33,359.2 C323.07,359.16 323.81,359.1 325.33,359 L325.53,359 L325.53,364.6 L325.73,364.6 C326.53,363.9 327.53,363.4 328.73,363.4 C331.33,363.4 332.93,365.6 332.93,368.6 C332.93,371.6 330.93,373.8 328.33,373.8 C327.53,373.8 326.73,373.7 325.73,373 L325.53,373 L324.13,373.8 L323.93,373.8 Z M336.195,363.8 L334.395,363.8 L334.395,363.6 L337.395,363.4 L337.795,363.4 L337.795,370.8 C337.795,372.1 338.195,373.2 339.695,373.2 C340.595,373.2 341.195,372.9 342.395,371.5 L342.395,363.8 L340.595,363.8 L340.595,363.6 L343.595,363.4 L343.995,363.4 L343.995,373.4 L345.795,373.4 L345.795,373.6 L342.595,373.8 L342.395,373.8 L342.395,372 L342.195,372 C341.195,373.1 340.155,373.8 338.695,373.8 C337.355,373.8 336.195,373 336.195,370.8 L336.195,363.8 Z M350.26,363.9 L350.26,371.4 C350.26,372.9 350.76,373.3 351.66,373.3 C352.06,373.3 352.56,373.2 353.26,372.9 L353.26,373.1 C352.26,373.6 351.66,373.8 350.66,373.8 C349.26,373.8 348.66,373.1 348.66,371.4 L348.66,363.9 L347.06,363.9 L347.06,363.7 L348.66,363.6 L350.06,361.2 L350.26,361.2 L350.26,363.6 L353.26,363.6 L353.26,363.9 L350.26,363.9 Z M356.525,363.8 L354.725,363.8 L354.725,363.6 L357.725,363.4 L358.125,363.4 L358.125,370.8 C358.125,372.1 358.525,373.2 360.025,373.2 C360.925,373.2 361.525,372.9 362.725,371.5 L362.725,363.8 L360.925,363.8 L360.925,363.6 L363.925,363.4 L364.325,363.4 L364.325,373.4 L366.125,373.4 L366.125,373.6 L362.925,373.8 L362.725,373.8 L362.725,372 L362.525,372 C361.525,373.1 360.485,373.8 359.025,373.8 C357.685001,373.8 356.525,373 356.525,370.8 L356.525,363.8 Z M371.090001,373.8 C369.830001,373.8 368.750001,373.22 368.090001,372.6 L367.990001,373.8 L367.790001,373.8 L367.790001,370.8 L367.990001,370.8 C368.230001,371.48 368.590001,372.16 369.050001,372.7 C369.510001,373.24 370.110001,373.6 370.890001,373.6 C372.290001,373.6 373.190001,372.72 373.190001,371.5 C373.190001,370 371.730001,369.56 370.590001,369.1 C369.050001,368.48 367.890001,367.8 367.890001,366.1 C367.890001,364.5 369.230001,363.4 371.290001,363.4 C372.110001,363.4 373.190001,363.7 374.090001,364.5 L374.190001,363.4 L374.390001,363.4 L374.390001,366.4 L374.190001,366.4 C373.890001,365.4 373.430001,364.72 372.910001,364.26 C372.390001,363.82 371.790001,363.6 371.190001,363.6 C369.990001,363.6 369.290001,364.42 369.290001,365.4 C369.290001,366.7 370.590001,367.3 371.690001,367.7 C373.170001,368.24 374.790001,369 374.790001,370.8 C374.790001,372.7 373.190001,373.8 371.090001,373.8 Z M383.020001,372.2 L382.820001,373.7 L382.620001,373.7 L382.520001,369.4 L382.720001,369.4 C382.880001,369.86 383.060001,370.34 383.220001,370.8 C384.000001,373 385.560001,373.6 386.880001,373.6 C388.700001,373.6 389.820001,372.6 389.820001,370.68 C389.820001,368.4 387.880001,367.64 386.380001,367 C384.360001,366.14 382.820001,365 382.820001,362.96 C382.820001,361 384.320001,359.4 387.060001,359.4 C388.280001,359.4 389.420001,359.8 390.320001,360.74 L390.520001,359.5 L390.720001,359.5 L390.820001,363.5 L390.620001,363.5 C390.420001,362.94 390.220001,362.36 390.020001,361.8 C389.460001,360.2 388.400001,359.6 387.080001,359.6 C385.400001,359.6 384.120001,360.7 384.120001,362.2 C384.120001,364.1 385.940001,364.92 387.380001,365.5 C389.380001,366.3 391.320001,367.6 391.320001,369.8 C391.320001,372.2 389.560001,373.8 386.880001,373.8 C385.440001,373.8 384.020001,373.1 383.020001,372.2 Z M396.785001,363.9 L396.785001,371.4 C396.785001,372.9 397.285001,373.3 398.185001,373.3 C398.585001,373.3 399.085001,373.2 399.785001,372.9 L399.785001,373.1 C398.785001,373.6 398.185001,373.8 397.185001,373.8 C395.785001,373.8 395.185001,373.1 395.185001,371.4 L395.185001,363.9 L393.585001,363.9 L393.585001,363.7 L395.185001,363.6 L396.585001,361.2 L396.785001,361.2 L396.785001,363.6 L399.785001,363.6 L399.785001,363.9 L396.785001,363.9 Z M405.050001,366 L405.250001,366 C406.150001,364.4 406.950001,363.4 407.950001,363.4 C408.590001,363.4 409.050001,363.84 409.050001,364.4 C409.050001,365.8 407.050001,365.9 406.950001,364.3 L406.750001,364.3 C406.230001,364.8 405.750001,365.5 405.050001,366.9 L405.050001,373.3 L406.850001,373.4 L406.850001,373.6 L401.650001,373.6 L401.650001,373.4 L403.450001,373.3 L403.450001,363.8 L401.850001,363.8 L401.850001,363.6 L404.850001,363.4 L405.050001,363.4 L405.050001,366 Z M418.715001,367.8 L411.875001,367.8 C411.815001,370.4 413.175001,372.7 415.515001,372.7 C416.815001,372.7 418.215001,371.8 418.715001,370.8 L418.915001,370.8 C418.515001,372.4 417.015001,373.8 415.115001,373.8 C412.015001,373.8 410.315001,371.3 410.315001,368.6 C410.315001,365.3 412.715001,363.4 415.215001,363.4 C417.115001,363.4 419.315001,364.5 418.715001,367.8 Z M415.115001,363.6 C413.395001,363.6 412.115001,365 411.915001,367.6 L416.915001,367.5 C417.415001,364.8 416.415001,363.6 415.115001,363.6 Z M429.580001,367.8 L422.740001,367.8 C422.680001,370.4 424.040001,372.7 426.380001,372.7 C427.680001,372.7 429.080001,371.8 429.580001,370.8 L429.780001,370.8 C429.380001,372.4 427.880001,373.8 425.980001,373.8 C422.880001,373.8 421.180001,371.3 421.180001,368.6 C421.180001,365.3 423.580001,363.4 426.080001,363.4 C427.980001,363.4 430.180001,364.5 429.580001,367.8 Z M425.980001,363.6 C424.260001,363.6 422.980001,365 422.780001,367.6 L427.780001,367.5 C428.280001,364.8 427.280001,363.6 425.980001,363.6 Z M435.045001,363.9 L435.045001,371.4 C435.045001,372.9 435.545001,373.3 436.445001,373.3 C436.845001,373.3 437.345001,373.2 438.045001,372.9 L438.045001,373.1 C437.045001,373.6 436.445001,373.8 435.445001,373.8 C434.045001,373.8 433.445001,373.1 433.445001,371.4 L433.445001,363.9 L431.845001,363.9 L431.845001,363.7 L433.445001,363.6 L434.845001,361.2 L435.045001,361.2 L435.045001,363.6 L438.045001,363.6 L438.045001,363.9 L435.045001,363.9 Z"
        id="Arbutus-Street"
        fill="#1A373C"
      />
    </>
  ),
  units: [
    {
      id: '403',
      mockup: (
        <g id="403" transform="translate(289.000000, 1.000000)">
          <polygon
            id="fill-403"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0.349720053 0.175122807 54.0525269 0.175122807 140.216952 0.175122807 212.549904 0.175122807 212.549904 103.942111 172.537432 103.942111 172.537432 136.762753 124.762399 136.762753 124.762399 158.690337 90.0425814 158.690337 90.0425814 155.365833 40.0093488 155.365833 40.0093488 103.942111 0.561426256 103.942111"
          />
          <text
            id="403"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="71.9575" y="86">
              403
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '402',
      mockup: (
        <g id="402" transform="translate(55.000000, 1.000000)">
          <polygon
            id="fill-402"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.327302 0.175122807 234.327302 103.942111 175.33184 103.942111 175.33184 155.365833 120.71164 155.365833 120.71164 184.154629 66.9382643 184.154629 66.9382643 150.272974 0.109672904 150.272974 0.109672904 0.175122807"
          />
          <text
            id="402"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="71.92" y="86">
              402
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '401',
      mockup: (
        <g id="401" transform="translate(55.000000, 152.000000)">
          <polygon
            id="fill-401"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0 8.27399184e-14 66.8952099 1.65479837e-13 66.8952099 34.0231228 120.46083 34.0231228 173.14514 34.0231228 173.14514 95.8447638 228.68384 95.8447638 228.68384 186.313733 0 186.313733"
          />
          <text
            id="401"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="85.085" y="119">
              401
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '406',
      mockup: (
        <g id="407" transform="translate(283.000000, 188.000000)">
          <polygon
            id="fill-406"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="219 150.663725 139.655525 150.663725 65.1349418 150.663725 0 150.663725 0 60.4776923 8.76225964 60.4776923 8.76225964 0.141468286 125.753485 0.141468286 166.683351 0 219.211706 0.141468286"
          />
          <text
            id="406"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="77.9025" y="83">
              406
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '405',
      mockup: (
        <g id="405" transform="translate(502.000000, 187.000000)">
          <polygon
            id="fill-405"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.710035 151.058964 0 151.583269 0 0.495139001 68.7323715 0.495139001 109.168256 0 234.710035 0"
          />
          <text
            id="405"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="85.9575" y="84">
              405
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '404',
      mockup: (
        <g id="404" transform="translate(502.000000, 1.000000)">
          <polygon
            id="fill-404"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.777914 185.144907 109.236135 185.144907 109.236135 155.719503 57.7915279 155.719503 57.7915279 103.871377 0.0663032268 103.871377 0.0663032268 0.175122807 154.470694 0.175122807 222 0.638415655 234.848482 53.0842618"
          />
          <text
            id="404"
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="96.31" y="86">
              404
            </tspan>
          </text>
        </g>
      ),
    },
  ],
};
